module.exports = __webpack_public_path__ + "static/media/offerBanner1.6d6f48c6.png";